<script lang="ts" setup>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import vuModal from '@ds/vuekit/src/components/vu-modal/vu-modal.vue';

import { useTranslations } from '~/composables/translations';

const props = defineProps<{
  passportUrl: string;
}>();

const emit = defineEmits(['close']);

const { $i18n } = useTranslations('components/TopBarMake/topbar_make');
const loading = ref(true);

const iframeUrl = computed(
  () =>
    `${
      props.passportUrl
    }/ds-connect-profile/service/3dexperience_profile/?dsconnect-client-proxy=${`${
      window.dsBaseUrl.endsWith('/') ? window.dsBaseUrl : `${window.dsBaseUrl}/`
    }?passportUpdate=true`}
`,
);

onMounted(() => {
  window.addEventListener('message', onMessageReceive);
});

onBeforeUnmount(() => {
  window.removeEventListener('message', onMessageReceive);
});
const onMessageReceive = (e: any) => {
  if (e && e.data === 'passportProfileUpdate') {
    emit('close');
  }
};

const closeModal = () => {
  loading.value = true;
  emit('close');
};
</script>
<template>
  <vu-modal :show="true" :show-footer="false" :title="$i18n('myProfile')" @close="closeModal()">
    <template #modal-body>
      <div id="profile-modal-container" v-mask="loading">
        <iframe
          :src="iframeUrl"
          style="min-height: 750px"
          @load="loading = false"
          frameborder="0"
        />
      </div>
    </template>
  </vu-modal>
</template>

<style scoped>
#profile-modal-container {
  margin: -10px -14px;
  height: 750px;
}
</style>
